<app-banner [heading]="'MEDIA COVERAGE'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>
<section class="events3">
  <div class="container" >

    <div class="row d-flex justify-content-between">


      <div class="col-md-4 d-flex align-items-stretch" *ngFor="let image of images;">
            <div class="card mx-md-2 mx-lg-0" >
              <div class="card-img">
                <img [src]="image.imgUrl" class="img-fluid" [alt]="image.caption">
              </div>
              <div class="card-body">
                <h5 class="card-title"> {{image.caption}} </h5>
                <p class="designation"> {{image.date}}</p>
              </div>
            </div>
          </div>
      </div>
  </div>
</section>